export default __webpack_public_path__ + "static/media/choose-spread.96c08473.png";